import * as Yup from 'yup';

// Definindo o esquema de validação com Yup
export const validationSchema = Yup.object().shape({
    name: Yup.string().required('Nome é obrigatório'),
    shortName: Yup.string().required('Descrição é obrigatória'),
    hexColorCode: Yup.string().required('Código hexadecimal é obrigatória'),
});